export const prescriptionFileError = (file) => {
  if (!file) return "Choose a prescription document.";
  if (!/\.(pdf|docx|png|jpe?g)$/i.test(file.name)) return "Choose a PDF, DOCX, PNG or JPEG file.";
  if (!file.size || file.size > 10 * 1024 * 1024) return "Choose a non-empty file up to 10 MB.";
  return "";
};
